//  Modules
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NGTdsModule } from "@tesla/ng-tds";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';

import { CommonModule } from "@angular/common";

//  Directives
import { SSNDirectives } from "./directives/ssn-mask.directive";

//  Components
import { AddressEditComponent } from "./address/address-edit.component";
import { ContactEditComponent } from "./contacts/contact-edit.component";
import { BankEditComponent } from "./bank/bank-edit.component";
import { TaxEditComponent } from "./tax/tax-edit.component";
import { DocumentsDialogComponent } from "./documents/documents-dialog/documents-dialog.component";
import { DocumentsGridComponent } from "./documents/documents-grid/documents-grid.component";
import { FileUploadService } from "./services/fileUpload.service";
import { SelectAutocompleteComponent } from "./autocomplete/select-autocomplete.component";
import { I18nService } from "../shared/services/i18n.service";
import { PayoutAngularModule } from '@tesla/payout-angular';
import { DiversityEditComponent } from './diversity/diversity-edit.component';
import { DiversityDocumentGridComponent } from './documents/diversity-document-grid/diversity-document-grid.component';
import { EhsEditComponent } from './ehs/ehs-edit/ehs-edit.component';
import { QuillModule } from "ngx-quill";
import { DynamicFormComponent } from "./dynamic-form/dynamic-form.component";
import { SharedModule } from "app/shared/shared.module";
import { DynamicFormFileUploadComponent } from "./file-upload/file-upload.component";
import { OnboardingContactsComponent } from './onboarding-contacts/onboarding-contacts.component';
import { TaxidTypeDisplayComponent } from './tax/taxid-type-display/taxid-type-display.component';
import { TaxidTypeDisplayChildComponent } from './tax/taxid-type-display-child/taxid-type-display-child.component';
import { DomainEditComponent } from './domain/domain-edit.component';
import { DatePickerComponent } from "./dynamic-form/date-picker/date-picker.component";
import { MsmeComponent } from './msme/msme.component';

const commonComponents = [
    AddressEditComponent, ContactEditComponent, BankEditComponent, TaxEditComponent, DiversityEditComponent, MsmeComponent,
    DiversityDocumentGridComponent, EhsEditComponent,DomainEditComponent, DynamicFormComponent, DynamicFormFileUploadComponent, OnboardingContactsComponent
];
@NgModule({
    imports: [CommonModule, FormsModule, NGTdsModule, ReactiveFormsModule,
        MatFormFieldModule, MatIconModule, MatTooltipModule, MatDialogModule,
        PayoutAngularModule,
        QuillModule.forRoot(), SharedModule],
    declarations: [...commonComponents, SSNDirectives,
        DocumentsDialogComponent, DocumentsGridComponent, SelectAutocompleteComponent, TaxidTypeDisplayComponent, TaxidTypeDisplayChildComponent, DomainEditComponent, DatePickerComponent, MsmeComponent],
    providers: [FileUploadService, I18nService],
    exports: [...commonComponents, QuillModule]
})
export class SupplierCommonModule { }